<template>
<div> 
  <report-layout-form ref="UpdateLayoutForm" mode="update" :onUpdate="doupdate"/>
  <report-layout-form ref="CreateLayoutForm" mode="create" :onUpdate="docreate"/>
<md-card class="searchPanel">
  <md-card-content v-if="searchRequest">
    <md-dialog :md-active.sync="isFilterModalShowing" >
      <div> 
       <md-dialog-title>Filter</md-dialog-title>
        <md-button class="custButton md-raised icon1" @click="isFilterModalShowing = false" >Close</md-button>
        <md-button class="custButton md-primary md-raised icon1" @click="doSearch">Search</md-button>
     </div>
     <md-dialog-content>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
          <md-field>
              <label>Mobile#</label>
              <md-input v-model="searchRequest.driverMobile"/>
          </md-field>
        </div>
<!--
        <div class = "inputBoxSpace" >
           <md-field>
              <label>LoadKey</label>
              <md-input v-model="searchRequest.seqNo"/>
          </md-field>
        </div>


      </div>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
          <md-field>
             <label>Booking #</label>
             <md-input v-model="searchRequest.bookingNo"/>
         </md-field>
       </div>
           
       <div class = "inputBoxSpace" >
        <md-field>
           <label>IBD #</label>
           <md-input v-model="searchRequest.ibd"/>
        </md-field>
       </div>
      </div>

      <div class = "inputBoxDouble" >
        <div class = "inputBoxSpaceWide" >
        <auto-complete-master-data-select
                                              group="GST_CARRIER"
                                              label="Carrier"
                                              :init-value="searchRequest.carrier"
                                              :on-item-changed="handleCarrierChanged"
                                              >
        </auto-complete-master-data-select>
        </div>
      </div>
      <div class = "inputBoxDouble" >
      <div class = "inputBoxSpace" >
        <md-field>
          <label>Yard</label>
          <md-input v-model="searchRequest.transloadingYard" disabled/>
        </md-field>
      </div>

      <div class = "inputBoxSpace" >
        <md-field>
          <label>Seal#</label>
          <md-input v-model="searchRequest.sealNumber"/>
        </md-field>
      </div>
-->
      </div>



    </md-dialog-content>
    
  </md-dialog>
  
      <div class="md-layout md-gutter" v-if="inbound_type">
        <div v-if="active" >
          <div class="result-included-outter-div">
            <div class="result-included-inner-div-radio">
              <span class="result-included-span-radio"> 
              ApptDate: 
              </span>
              <md-radio v-model="selectapptDate" value="apptDate_null"  @change="onSelectappt" >Only empty apptDate</md-radio>
              <md-radio v-model="selectapptDate" value="apptDate"  @change="onSelectappt" >All apptDate</md-radio>  
          </div>
        
        </div> 
      </div> 


        <div v-if="active" >
          <div class="result-included-outter-div">
            <div class="result-included-inner-div">
              SAP status:  
            </div>
        <div class="result-included-div-span">
        <span>
          <md-checkbox v-model="filtersapStatus_x"><label>Already sent</label></md-checkbox> 
        </span>
        <span class="result-included-span"> 
          <md-checkbox v-model="filtersapStatus_null"><label>Not yet</label></md-checkbox>
        </span>
        </div>
        </div> 
      </div>
      </div>
 
      <div class="md-layout md-gutter" v-if="inbound_type">

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateF" class = "inputBox">
            <datepicker v-model="inboundSearchRequest.apptDate.startDate">
              <label>Appt date</label>
            </datepicker>
          </div>
        </div>

        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refapptDateT" class = "inputBox">
            <datepicker v-model="inboundSearchRequest.apptDate.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
          <md-field>
            <label>IBS</label>
            <md-input v-model.trim="inboundSearchRequest.ibs"/>
          </md-field>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
          <md-field>
            <label>IBD</label>
            <md-input v-model.trim="inboundSearchRequest.ibd"/>
          </md-field>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
          <md-field>
            <label>PO</label>
            <md-input v-model.trim="inboundSearchRequest.po"/>
          </md-field>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refibsprocessDateF" class = "inputBox">
            <datepicker v-model="inboundSearchRequest.ibs_process_DT.startDate">
              <label>IBS process date</label>
            </datepicker>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div ref = "refibsprocessDateT"  class = "inputBox">
            <datepicker v-model="inboundSearchRequest.ibs_process_DT.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox" >
          <auto-complete-master-data-multiple-select
                                             group="IBS_TYPE"
                                             label="IBS Type"
                                             v-model="inboundSearchRequest.ibs_types">
        </auto-complete-master-data-multiple-select>
       </div>
      </div>  

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <auto-complete-master-data-select
                                      group="INBOUND_STATUS"
                                      label="Inbound Status"
                                      :init-value="inboundSearchRequest.inboundStatus"
                                      :on-item-changed="handleStatusChanged_inbound"
          >
          </auto-complete-master-data-select>
        </div>
      </div>
    
    <div
      v-if="active"
      class="md-layout-item md-size-20 md-small-size-30">
      <div class = "inputBox" >
        <auto-complete-master-data-select
                                          group="DOCKTYPE"
                                          label="Dock Type"
                                          :init-value="inboundSearchRequest.dockType"
                                          :on-item-changed="handleDockChanged"
                                          >
      </auto-complete-master-data-select>
      </div>
    </div>  
   
     </div>   

     <!---->

      <div class="md-layout md-gutter" v-if="outbound_type">
        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
            <auto-complete-master-data-select
                                              group="REC_WINDOW"
                                              label="Rev. Windows"
                                              :preparedOptions="loaded_recwin"
                                              :init-value="outboundSearchRequest.receivingWindows"
                                              :on-item-changed="handleWindowsChanged"
                                              >
          </auto-complete-master-data-select>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
            <md-field>
                <label>Container#</label>
                <md-input v-model="outboundSearchRequest.containerNo"/>
            </md-field>
          </div>
        </div>



        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
            <datepicker v-model="outboundSearchRequest.gwDate.startDate">
              <label>GW Scale Date</label>
            </datepicker>
          </div>
        </div>
  
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
            <datepicker v-model="outboundSearchRequest.gwDate.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div>
  
        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
           <md-field>
              <label>Input WTicket</label>
              <md-input v-model="outboundSearchRequest.scanWt"/>
          </md-field>
          </div>      
        </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
        <md-field>
          <label>IBS</label>
          <md-input v-model="outboundSearchRequest.ibs"/>
        </md-field>
        </div>
      </div>


      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="outboundSearchRequest.chzStartDate.startDate">
            <label>Out Gate Date</label>
          </datepicker>
        </div>
      </div>

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="outboundSearchRequest.chzStartDate.endDate">
            <label>To</label>
          </datepicker>
        </div>
      </div>

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="outboundSearchRequest.chzEndDate.startDate">
            <label>In Gate Date</label>
          </datepicker>
        </div>
      </div>

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="outboundSearchRequest.chzEndDate.endDate">
            <label>To</label>
          </datepicker>
        </div>
      </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
     <div class = "inputBox">
        <auto-complete-master-data-select
                                      :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS')"
                                      label="Status"
                                      :init-value="outboundSearchRequest.loadStatus"
                                      :on-item-changed="handleStatusChanged_outbound"
                                      >
        </auto-complete-master-data-select>
      </div>
      </div>


      </div>

      <!---->

      <div class="md-layout md-gutter" v-if="unmatch_type">
      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="startDate">
            <label>Log Create Date</label>
          </datepicker>
        </div>
        <div class = "inputBox">
          <md-field>
            <md-input v-model="dataForm.ibs"></md-input>
            <label>Inbound Shipment</label>
          </md-field>
        </div>
      </div>

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="endDate">
            <label>To</label>
          </datepicker>
        </div>
        <div class = "inputBox">
            <auto-complete-master-data-select
                        group="OFFICE_IP"
                        label="Scale Location"
                        displayType="idOnly"
                        :init-value="dataForm.actualScaleLocation"
                        :on-item-changed="handleLocationChanged"
                    >
            </auto-complete-master-data-select>
        </div>
      </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
            <auto-complete-master-data-select
                        group="REC_WINDOW"
                        label="Appt Rev. Windows"
                        :init-value="dataForm.apptRecWin"
                        :on-item-changed="handleApptWindowsChanged"
                    >
            </auto-complete-master-data-select>
        </div>
      </div>
      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
            <auto-complete-master-data-select
                        group="REC_WINDOW"
                        label="IBS Rev. Windows"
                        :init-value="dataForm.ibsRecWin"
                        :on-item-changed="handleIBSWindowsChanged"
                    >
            </auto-complete-master-data-select>
        </div>
      </div>


      </div>
      <!---->
        <div class="md-layout md-gutter">
          <div class="result-included-outter-div">
            <div class="result-included-inner-div-radio">
              <span class="result-included-span-radio"> 
              Report Type: 
              </span>
              <md-radio v-model="selectreportType" value="report_inbound"  @change="onSelectreport" >Inbound</md-radio>
              <md-radio v-model="selectreportType" value="report_outbound"  @change="onSelectreport" >Outbound</md-radio>  
              <md-radio v-model="selectreportType" value="report_unmatch"  @change="onSelectreport" >Un-Match</md-radio>  
            </div>
          </div> 
          <div class="result-included-outter-div-btn1">
            <div class="result-included-inner-div-btn1">
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_default"  @change="onSelectreport" >Default</md-radio>-->
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_1"  @change="onSelectreport" >1</md-radio>-->
              <!--<md-radio v-model="selectInboundLayout" value="inbound_layout_2"  @change="onSelectreport" >2</md-radio>-->
              <div class = "inputBox layout-input">
                 <auto-complete-select
                        :label="layout_type"
                        :value="selectedLayout"
                        :on-item-changed="handleLayoutChanged"
                        :options="userLayoutNameList"
                    >   
                 </auto-complete-select>
              </div>
              <div class="layout-div">
                  <md-button class="custButton md-raised icon1 align-right" @click="createLayout" >Create</md-button>
                  <md-button class="custButton md-raised icon1 align-right" @click="updateLayout" >Update</md-button> 
                  <md-button class="md-raised custButton icon1 align-right" @click="doReloadLayout">Reload</md-button>
                  <md-button class="custButton md-raised icon1 align-right" @click="loadLayout" >Load</md-button>
              </div>
            </div>
          </div> 
        </div> 

      <!---->
    </md-card-content>   

   <md-card-actions md-alignment="space-between">
    <div class="md-layout-item md-size-100 md-small-size-100">
          <!--<callingApiCenter path="/api/w/fsi/GetIBSOutbound" :not-display-error="true">-->
              <!--<md-button class="md-raised custMenuButton" @click="refreshAction">Refresh</md-button>-->
              <md-button id = "searchTag" class="md-raised custMenuButton md-primary" @click="doSearch">Search</md-button>
              <md-button class="md-raised custMenuButton" @click="doClear">Clear</md-button>
              <md-button class="md-raised custMenuButton" @click="doDownloadExcel" :disabled="!getDownloadCond">Download</md-button>
              
              <!--<md-button class="md-raised custMenuButton" @click="filterBar"> Filter </md-button>-->
              <input
                  class="custSearchBar"
                  type="text"
                  placeholder="Searching Term"
                  v-model="filter"
                />
              <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
                <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
              </md-button>

          <!--</callingApiCenter>-->
      </div>
  </md-card-actions>
    

 
</md-card>
            <callingApiCenter
              :paths="[
                '/api/w/fsi/WebSearchFSIContainerUpdateLog',
                '/api/w/fsi/GetIBSInboundNew',
                '/api/w/fsi/GetIBSOutbound',
                '/api/w/layout/Search'
              ]"
            >

<pagination :items="filteredRows">
  <template slot-scope="{pageItems}">
    <md-card class="data-table-container">
      <div class="outer-container">
        <div class="inner-container">
          <div class="table-header">
            <table id="headertable" v-if="inbound_type || outbound_type || unmatch_type">
              <thead>
                <tr>
                  <th v-for="(value, key) in loaded_user_layout" :key="key"
                     class="header-cell center" v-bind:class="{ w5: value.colWidth == '5', w7: value.colWidth == '7', w10: value.colWidth == '10'}"
                     @click="sortFunction(value.colDataElement)"
                   >
                     {{ value.colHeaderText }}
                   </th>  

                </tr>
              </thead>
            </table>
            <!--
            <table id="headertable" v-if="outbound_type">
              <thead>
                <tr>
                <th
                class="header-cell center w5"
                v-on:click="sortFunction('loadStatus')">
                Load Status
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('sapStatus')">
                SAP Status
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('receivingWindows')">
                Receiving Window
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('chzEndDate')">
                In Gate Date
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('chzStartDate')">
                Out Gate Date
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('newSeal')">
                Seal No
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('grade')">
                Grade
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('scaleTicket')">
                Weight Ticket
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('containerNo')">
                Container No
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('chassisNo')">
                Chassis No
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('bookingNo')">
                Booking No
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwDate')">
                Scale Date (G)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwDate')">
                Scale Time (G)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwDateWeb')">
                Scale Time Web (G)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwStation')">
                GW Station
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwYgNo')">
                Yard Goat (G)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwYgWeight')">
                GW-YG-Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwYgWeight')">
                Gross Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twDate')">
                Scale Date (T)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twDate')">
                Scale Time (T)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twDateWeb')">
                Scale Time Web (T)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twStation')">
                TW Station
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twYgNo')">
                Yard Goat (T)
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twYgWeight')">
                TW-YG Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twYgWeight')">
                Tare Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('weight')">
                Net Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('bales')">
                Bale
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('outboundRemark')">
                Outbound Remark
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('carrier2')">
                BK Carrier
              </th>

            </tr>
              </thead>
            </table>
          
            <table id="headertable" v-if="unmatch_type">
              <thead>
                <tr>
                <th
                class="header-cell center w5"
                v-on:click="sortFunction('user')">
                User
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('webModule')">
                Update Web Module
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('createdAt')">
                Update Date/Time
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('apptRecWin')">
                Appt Receving Window
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('ibsRecWin')">
                IBS Receving Window
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('apptDate')">
                Appt Date
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('chzEndDate')">
                In Gate Date
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('matnr')">
                Material
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('scaleTicket')">
                Weight Ticket
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('ibs')">
                IBS
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('containerNo')">
                Container No
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwYgNo')">
                GW-YG No
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('gwYgWeight')">
                GW-YG Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('vgmWeight')">
                Gross Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twYgNo')">
                TW-YG No
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('twYgWeight')">
                TW-YG Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('tareWeight')">
                Tare Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('weight')">
                Net Weight
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('bales')">
                Bale Count
              </th>
              </tr>
              </thead>
            </table>
          -->
          </div>
          <div class="table-body " @scroll="handleScroll">
            <table id="bodytable" v-if="inbound_type || outbound_type || unmatch_type">
              <tbody>
                <tr :key="item.messageId" class="" v-for="item in pageItems">
                   <td v-for="(value,key) in loaded_user_layout" :key="key"
                      class="body-cell excelBox" v-bind:class="{ w5: value.colWidth == '5', w7: value.colWidth == '7', w10: value.colWidth == '10'}"
                   >
                   <template v-if="value.colDataType == 'DATE'">
                       {{ item[value.colDataElement] | date }}
                   </template>
                   <template v-else>
                      <template v-if="value.colDataType == 'TIME'">
                         {{ item[value.colDataElement] | time }}  
                      </template>
                      <template v-else>
                         {{ item[value.colDataElement] }} 
                      </template>
                   </template>
                   </td>   
                </tr>
              </tbody>
            </table>
            <!--  
            <table id="bodytable" v-if="outbound_type">
              <tbody>
                <tr :key="item.messageId" class="" v-for="item in pageItems">
                  <td class="body-cell excelBox w5" >
                    {{ item.loadStatus }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.sapStatus }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.receivingWindows }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.chzEndDate | date }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.chzStartDate | date }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.newSeal }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.grade }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.scaleTicket }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.containerNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.chassisNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.bookingNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.gwDate | date }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.gwDate | time }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.gwDateWeb | time }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.gwStation }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.gwYgNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.gwYgWeight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.vgmWeight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.twDate | date }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.twDate | time }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.twDateWeb | time }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.twStation }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.twYgNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.twYgWeight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.tareWeight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.weight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.bales }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.outboundRemark }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.carrier2 }}
                  </td>

                </tr>
              </tbody>
            </table>
          
            <table id="bodytable" v-if="unmatch_type">
              <tbody>
                <tr :key="item.messageId" class="" v-for="item in pageItems">
                  <td class="body-cell excelBox w5" >
                    {{ item.user }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.webModule }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.createdAt | date }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.apptRecWin }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.ibsRecWin }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.apptDate | date }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.chzEndDate | date }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.matnr }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.scaleTicket }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.ibs }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.containerNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.gwYgNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.gwYgWeight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.vgmWeight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.twYgNo }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.twYgWeight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.tareWeight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.weight }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.bales }}
                  </td>
              </tr>
              </tbody>
            </table>
          -->
          </div>
        </div>
      </div>
    </md-card>
  </template>
</pagination>
</callingApiCenter>

</div>
</template>


<style scoped>
@import '../../public/chris.css';

.excelBox {
padding-top: 15px;
padding-bottom: 15px;
padding-left: 5px;
padding-right: 5px;
text-align: center;

}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
vertical-align: middle;
margin-right: 10px;
}

.inputBox {
border: 1px solid #cacbcc;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 5px 5px 5px 5px;
margin-top: 5px;
}

.inputBox:hover {

border: 2px solid #448aff;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 6px 6px 6px 6px;
margin-top: 5px;
background-color: #e0eff7;
  
}

  .inputBoxOutbound {
    border: 1px solid #cacbcc;
    border-radius: px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

  .inputBoxOutbound:hover {
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
  }


/* .selected {
 background: #726a95;
} */

.tableW {
height: 40px;
}

.center {
text-align: center;
}

tr:hover {
background: #c8e6f5;
}

.headerCenter {
text-align: center;
}


.modal {
 background-color: #29303b;
  border-radius: 5px;
}
.modalTitle {
font-weight: normal;
font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
font-weight: 500;
color: white;
font-family: Poppins, sans-serif;
margin-bottom: 0.5rem;
line-height: 1.6;
}

.md-menu {
padding: 0;
padding: 0;

}

.custButton {
margin: 10px;
width: 120px;
height: 40px;
line-height:40px;
font-size: 0.8rem;

}

.custMenuButton {

width: 110px;
height: 40px;
line-height:45px;
font-size: 0.9rem;
align-self: center;

}

.custSearchBar{
  margin: 10px;
width: 200px;
height: 40px;
line-height:40px;
font-size: 0.9rem;
}


.custButtonRight {
margin: 10px;
width: 100px;
height: 40px;
float : right;
}

.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

.inputBoxDouble {
    /* border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px; */
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  }

  .icon1 {
    float: right;
    margin: 5px;
}

.inputBoxSpaceWide {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 400px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: auto;
    padding: 10px;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-inner-div {
    margin-left: 5px;
    font-weight: bold;
    margin-bottom: -25px;
}
.result-included-div-span {
    margin-left: 100px; 
    margin-top: -10px;
}
.result-included-span {
    margin-left: 5px;
}
.custSearchBar {
  height: 40px;
  margin: 2px 15px !important;
  vertical-align:top;
}
.result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: auto;
    padding: 10px;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-outter-div-btn {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: auto;
    padding: 0px;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-inner-div-radio {
    margin-left: 5px;
    margin-bottom: -25px;
    margin: -12px;
}
.result-included-span-radio {
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    position:relative;
    top: -5px;
}
.result-included-inner-div-btn {
    margin-left: 5px;
    margin-top: 10px;
    margin-bottom: 0px;
}
.result-included-span-btn {
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    position:relative;
    top: -5px;
}
.result-included-outter-div-btn1 {
    border: 1px solid #D0D0D0;
    background-color: rgba(161, 103, 103, 0.3);
    border-radius: 5px;
    width: 785px;
    padding: 0px;
    height: 70px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-inner-div-btn1 {
    margin-left: 5px;
    margin-top: 10px;
    margin-bottom: 0px;
}

.align-right {
    float: right;
}
.layout-input {
    width: 250px;
    margin-top: -5px;
}
.layout-div {
    margin-top:-60px; 
    margin-left: 80px;
    padding: 2px;
}


</style>

<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import dateFormat from '../utils/dateFormat';
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
import sort from "fast-sort";
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
import { times } from 'underscore';
import ReportLayoutForm from "../components/ReportLayoutForm.vue";

const getInitSearch = () => ({

  //driverMobile: null,
  logCreateDate: {
    startDate: null,
    endDate: null,
  },
  office: null,
  user: null,
  unmatchRecWin: null,
  fromScaling: true,  
  apptRecWin: null,
  ibsRecWin: null,
  ibs: null,
  actualScaleLocation: null,
});

const getInitInboundSearch = () => ({

  //driverMobile: null,
  apptDate: {
    startDate: null,
    endDate: null,
  },
  ibs: null,
  ibd: null,
  po: null,
  ibs_process_DT: {
    startDate: moment().subtract(1,'months').startOf('d').toDate(),
    endDate: moment().endOf('d').toDate(),
  },
  po_lsd: {
    startDate: null,
    endDate: null,
  },
  ibs_types: [],  
  inboundStatus: null,
  dockType: null,
});

const getInitOutboundSearch = () => ({

  //driverMobile: null,
  receivingWindows: null,
  containerNo: null,
  gwDate: {
    startDate: null,
    endDate: null,
  },
  scanWt: null,
  ibs: null,
  chzStartDate: {
    startDate: null,
    endDate: null,
  },
  chzEndDate: {
    startDate: null,
    endDate: null,
  },
  loadStatus: null,
  outboundDate: {
      startDate: null,
      endDate: null,
  },
  transloadingYard: '1010001',
});

const getInitialInboundUnmatchLog = () => ({
  office: null,
  seqNo: null,
  apptNo: null,
  user: null,
  webModule: null,
  apptRecWin: null,
  ibsRecWin: null,
  ibs: null,
  actualScaleLocation: null,
  unmatchRecWin: null,
  createdBy: null,
  createdAt: null,
  updatedBy: null,
  updatedAt: null,
});

const getInitialLayoutSearchRequest = () => ({
   office: null,
   layoutOwner: null,
   layoutName: null,
   reportModule: null,
   colIndex: null,
   onlyActive: null,
   layoutnamelist: null,
});

const reportLayoutElements = () => ({
   orderIndex: null,
   colHeaderText: null,
   colDataElement: null,
   colDataType: null,
   colWidth: null,
});

export default {

data: () => ({
  searchRequest: getInitSearch(),
  inboundSearchRequest: getInitInboundSearch(),
  outboundSearchRequest: getInitOutboundSearch(),
  dataForm: getInitialInboundUnmatchLog(),
  layoutSearchRequest: getInitialLayoutSearchRequest(),
  active: true,
  isFilterModalShowing:false,
  items:[],
  items_inbound:[],
  items_outbound:[],
  userLayoutNameList: [], 
  inbound_user_layout: [],
  inboundDataElmList: [],
  inboundHeaderTextList: [],
  inboundColWidth10: [],
  inboundColWidth5: [],
  inboundColWidth7: [],
  inboundDateFields: [],
  inboundTimeFields: [],
  loadedUserLayout: [],
  inbound_default_allCols: [],
  inbound_layout_userspec: false,
  inbound_layout_setdefault: false,

  loaded_user_layout: [],
  loaded_default_allCols: [],
  loaded_layout_userspec: false,
  loaded_layout_setdefault: false, 

  //inboundAllColList: [],
  //drivers: [],
  //smslog:[],
  sortStatus: null,
  startdate: null,
  enddate: null,
  isdisableSend: true,
  isdisablephoto: true,
  filter: "",
  layout1: false,
  layout2: true,
  selectreportType: 'report_inbound',
  selectInboundLayout: 'inbound_layout_default',
  inbound_type: true,
  outbound_type: false,
  unmatch_type: false,
  filtersapStatus_x: true,
  filtersapStatus_null: true,
  selectapptDate: 'apptDate_null',
  layout_type: 'Inbound Layout',
  selectedLayout: null,
  //getLog: [],
  loaded_recwin: [],
  loaded_recwin_id: [],
}),


components: {
  callingApiCenter,
  ReportLayoutForm
},

watch: {
  getFSIInboundUnmatchReport(val) {
    this.updateItems(val);
  },
  getibsInbound(val) {
    this.updateibsInbound(val);
  },
  getibsOutbound(val) {
    this.updateibsOutbound(val);
  },
  getreportlayoutdata(val) {
    this.updateReportLayout(val); 
  },


},

computed: {
...mapGetters([
    'getPermission',
    'getUserProfile',
    'getRole',
    'getMasterDataAsSelectOptionByGroup',
    "getMasterDataByGroup",
    'getFSIInboundUnmatchReport',
    'getibsInbound',
    'getibsOutbound',
    'getreportlayoutdata'
  ]),

  filteredRows(){
        //return _(this.items).sortBy((it) => {it.CreatedAt});
        if (this.unmatch_type)
        {
           return this.items.filter(it => this.loaded_recwin_id.includes(it.receivingWindows)).filter((row) => {
             const term = this.filter.toUpperCase().trim();
             return (
               this.includeNull(row.apptNo).includes(term) ||
               this.includeNull(row.inboundShipment).includes(term) ||
               this.includeNull(row.apptRecWin).includes(term) ||
               this.includeNull(row.ibsRecWin).includes(term) ||
               this.includeNull(row.actualScaleLocation).includes(term) ||
               this.includeNull(row.containerNo).includes(term)
             );
           })
        };
        if (this.inbound_type)
        {
           console.log(`return result before filter: ${JSON.stringify(this.checkboxFilter)}`)
           console.log(`rec win id: ${JSON.stringify(this.loaded_recwin_id)}`);
           console.log(`return result: ${JSON.stringify(this.checkboxFilter.filter(it => (this.loaded_recwin_id.includes(it.receivingWindows) || it.receivingWindows == null)))}`)
           return this.checkboxFilter.filter(it => (this.loaded_recwin_id.includes(it.receivingWindows) || it.receivingWindows == null)).filter((row) => {
             const term = this.filter.toUpperCase().trim();
             return (
              this.includeNull(row.ibs).includes(term) ||
              this.includeNull(row.po).includes(term) ||
              this.includeNull(row.apptNo).includes(term) ||
              this.includeNull(row.scaleTicket).includes(term)
            );
           });
        };
        if (this.outbound_type)
        {
           return this.items_outbound.filter(it => this.loaded_recwin_id.includes(it.receivingWindows)).filter((row) => {
            const term = this.filter.toUpperCase().trim();
            return (
              this.includeNull(row.containerNo).includes(term) ||
              this.includeNull(row.chassisNo).includes(term) ||
              this.includeNull(row.scaleTicket).includes(term) ||
              this.includeNull(row.scanWt).includes(term) ||
              this.includeNull(row.bookingNo).includes(term) ||
              this.includeNull(row.ibs).includes(term)
            );
           });
        }
      },

  getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

  getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

  canEdit() {
        return this.getSelectedItems.length === 1 ;
      },

  // getSMSLog() {
  //     return this.smslog;
  //   },  


  getOutboundStatus() {
     return [
        {
          id: 'EPT',
          name: 'EMPTY',
        },
        {
          id: 'LD',
          name: 'LOADED',
        },
        {
          id: 'ASN',
          name: 'Assigned',
        },
        {
          id: 'OU',
          name: 'Outbound',
        },
     ]
  },
  getDownloadCond() {
      
      //const item = _(this.items).filter((it) => it.selected);
      //if ( this.edit.mode == null && this.items.length != 0 && item.length == 0  ) return this.items;
      return this.items.length > 0 || 
             this.items_inbound.length > 0 || 
             this.items_outbound.length > 0;
  
    },
  checkboxFilter(){
   
    if (this.filtersapStatus_x === true && this.filtersapStatus_null === false){
         return  _(this.items_inbound).filter(it => it.sapStatus == 'X');
    }
    if (this.filtersapStatus_null === true && this.filtersapStatus_x === false){
        return  _(this.items_inbound).filter(it => it.sapStatus == null);
    }
   
    else
    {
      return this.items_inbound;
    }
    },

},    
async mounted() {
      // const alldrivers = await this.$store.dispatch(
      //     'getDriversBySource',
      //     {
      //       defaultSalesOffice: 'LGB',
      //       driverOffice: 'FSI',
      //       source: 'OUTBOUND',
      //     }
      // );
      // console.log("alldrivers: " + JSON.stringify(alldrivers));
      // this.drivers = alldrivers;

    const cachedSearchRequest = this.searchRequest;
    if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
    this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
  } else {
   this.searchRequest = getInitSearch(this);
   this.searchRequest.user = "INBOUND";
   //this.searchRequest.unmatchRecWin = true;
  }

  var p_loaded_recwin = this.getMasterDataByGroup('REC_WINDOW');
  if (p_loaded_recwin.length > 0)
  {
    if (!this.getPermission.stc.view)
    {
        this.loaded_recwin = p_loaded_recwin.filter( it => it.tagName != 'STC');
    } else {
        this.loaded_recwin = p_loaded_recwin;
    }
    this.loaded_recwin.forEach((it) => {
       this.loaded_recwin_id.push(it.tagId); 
    });
    console.log(`inbound rec win1 : ${JSON.stringify(this.loaded_recwin)}`);

  } else {
    //this.inbound_recwin = api.post('/api/w/masterData', {groups: ['REC_WINDOW']}).filter( it => it.tagName != 'STC');
    //api.post('/api/w/masterData', {groups: ['REC_WINDOW']})
    newAPIPost('/api/w/masterData', {groups: ['REC_WINDOW']})
      .then((res) => {
          p_loaded_recwin = res.filter(it => it.tagName != 'STC' && it.active);
          p_loaded_recwin.forEach((it) => {
            it.id = it.tagId;
            it.name = it.tagName;
            if (this.getPermission.stc.view)
            {
              this.loaded_recwin.push(it);
              this.loaded_recwin_id.push(it.tagId)
            }
          })
          console.log(`inbound rec win: ${JSON.stringify(this.inbound_recwin)}`);
    });
  }

  this.doReloadLayout();
  /*
  console.log("this.smslog:" + this.searchRequest);
        //const cachedSearchRequest1 = this.$store.state.gstDriverMaster.searchRequest;
        const cachedSearchRequest1 = this.$store.state.stcSMSLog
        //this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        this.$el.querySelector('#searchTag').click();
        console.log("this.getSTCSMSLog:" + this.getSTCSMSLog);
        this.updateItems(this.getSTCSMSLog);
        */

},

 methods: {

  // handleStatusChanged(id) {
  //     this.searchRequest.loadStatus = id;
  //     if (id != 'OU')
  //     {
  //       this.searchRequest.gwDate.startDate = null;
  //       this.searchRequest.gwDate.endDate = null;
  //     }
  //   },

  //   handleCarrierChanged(id) {
  //     this.searchRequest.carrier = id;
  //   },

  //   handleWindowsChanged(id) {
  //       this.searchRequest.receivingWindows = id;
  //   },

      handleDriverChanged() {
        return (id, name, unit, weight, plate, trail) => {
          //console.log("itsm driverPh: " + item.driverPh);
          //item.driverPh = "";
          //console.log(`Item is ${item}`)
          //item.moveInBy = id;
          //item.driverPh = name;
          this.searchRequest.shortId = id;
          this.searchRequest.driverMobile = name;
          //this.dataForm.truckLic = plate;
          //console.log(`Phone is ${item.driverPh}`);
          //item.message = "3555";
          //this.$forceUpdate()
          console.log("selected Items shortId: " + name);
          //console.log("selected Items driverPh: " + item.driverPh);
          //console.log("selected item index: " + item.index);
          //if (item.index > -1)
          //{
          //    console.log("selected item driverPh: " + this.smslist[item.index].driverPh);
          //}
          //if (document.getElementById("smsoutbound"))
          //{
          //   console.log("find smsoutbound element");
          //   document.getElementById("smsoutbound").refresh;
         // }
        };
      },

    handleApptWindowsChanged(id)
    {
        this.dataForm.apptRecWin = id;
    },
    handleIBSWindowsChanged(id)
    {
        this.dataForm.ibsRecWin = id;
    },
    handleLocationChanged(id)
    {
        this.dataForm.actualScaleLocation = id;
    },
    handleStatusChanged_inbound(id)
    {
        this.inboundSearchRequest.inboundStatus = id;
    },
    handleStatusChanged_outbound(id)
    {
         this.outboundSearchRequest.loadStatus = id;
    },
    handleDockChanged(id) 
    {
        this.inboundSearchRequest.dockType = id;
    },
    handleWindowsChanged(id)
    {
        this.outboundSearchRequest.receivingWindows = id;
    },
    handleLayoutChanged(id)
    {
        console.log(`change layout id: ${id}`);
        this.selectedLayout = id;
        //this.doReloadLayout();
    },

    mouseOver: function(){
        this.active = true;
    },

    mouseLeave: function() {
      this.active = !this.active;
    },

    updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
        },

    // updatesmslog(log) {
    //   var items = JSON.parse(JSON.stringify(log));
    //   this.smslog = items;
    // },

    updateibsInbound(ibsinbound) {
      var items = JSON.parse(JSON.stringify(ibsinbound));
      console.log(`inbound ibs list: ${JSON.stringify(items)}`);
      
      if( this.selectapptDate == "apptDate_null"){
        this.items_inbound = items.filter(it => it.apptDate == null)
      }
      else{
        this.items_inbound = items;
      }
    },

    updateibsOutbound(ibsoutbound) {
      var items = JSON.parse(JSON.stringify(ibsoutbound));
      console.log(`outbound ibs list: ${JSON.stringify(items)}`);
      
      // if( this.selectapptDate == "apptDate_null"){
      //   this.items_inbound = items.filter(it => it.apptDate == null)
      // }
      // else{
      //   this.items_inbound = items;
      // }
      this.items_outbound = items;
    },

    updateReportLayout(source) {
      var items = JSON.parse(JSON.stringify(source));
      console.log(`inbound user layout: ${JSON.stringify(items)}`);
      this.loadedUserLayout = [];
      this.loadedUserLayout = items;
    },

    loadInboundAllColList()
    {
        //this.inboundDataElmList.push('inboundStatus');
        //this.inboundDataElmList.push('sapStatus');
        //this.inboundDataElmList.push('receivingWindows');
        //this.inboundDataElmList.push('apptDate');
        //this.inboundDataElmList.push('apptTime');
        //this.inboundDataElmList.push('apptNo');
        //this.inboundDataElmList.push('matnr');
        // this.inboundDataElmList.push('scaleTicket');
        // this.inboundDataElmList.push('ibs');
        // this.inboundDataElmList.push('trailerNo');
        // this.inboundDataElmList.push('po');
        // this.inboundDataElmList.push('gwDate');
        // this.inboundDataElmList.push('gwTime');
        // this.inboundDataElmList.push('gwDateWeb');
        // this.inboundDataElmList.push('gwStation');
        // this.inboundDataElmList.push('gwYgNo');
        // this.inboundDataElmList.push('gwYgWeight');
        // this.inboundDataElmList.push('vgmWeight');
        // this.inboundDataElmList.push('twDate');
        // this.inboundDataElmList.push('twTime');
        // this.inboundDataElmList.push('twDateWeb');
        // this.inboundDataElmList.push('twStation');
        // this.inboundDataElmList.push('twYgNo');
        // this.inboundDataElmList.push('twYgWeight');
        // this.inboundDataElmList.push('tareWeight');
        // this.inboundDataElmList.push('weight');
        // this.inboundDataElmList.push('bales');
        // this.inboundDataElmList.push('loadRemark');
        // this.inboundDataElmList.push('plasticCount');
        // this.inboundDataElmList.push('palletCount');
        // this.inboundDataElmList.push('plasticWeight');
        // this.inboundDataElmList.push('palletWeight');
        // this.inboundDataElmList.push('supplier_name');
        // this.inboundDataElmList.push('route_desc');
        // this.inboundDataElmList.push('moveInBy');

        // this.inboundHeaderTextList.push('Inbound Status');
        // this.inboundHeaderTextList.push('SAP status');
        // this.inboundHeaderTextList.push('Receiving Window');
        // this.inboundHeaderTextList.push('Appointment Date');
        // this.inboundHeaderTextList.push('Appointment Time');
        // this.inboundHeaderTextList.push('Appointment No');
        // this.inboundHeaderTextList.push('Material');
        // this.inboundHeaderTextList.push('Weight Ticket');
        // this.inboundHeaderTextList.push('IBS');
        // this.inboundHeaderTextList.push('Trailer#');
        // this.inboundHeaderTextList.push('PO');
        // this.inboundHeaderTextList.push('GW Date');
        // this.inboundHeaderTextList.push('GW Time');
        // this.inboundHeaderTextList.push('GW Time Web');
        // this.inboundHeaderTextList.push('GW Station');
        // this.inboundHeaderTextList.push('GW-YG-No');
        // this.inboundHeaderTextList.push('GW-YG-Weight');
        // this.inboundHeaderTextList.push('Gross Weight');
        // this.inboundHeaderTextList.push('TW Date');
        // this.inboundHeaderTextList.push('TW Time');
        // this.inboundHeaderTextList.push('TW Time Web');
        // this.inboundHeaderTextList.push('TW Station');
        // this.inboundHeaderTextList.push('TW-YG-No');
        // this.inboundHeaderTextList.push('TW-YG Weight');
        // this.inboundHeaderTextList.push('Tare Weight');
        // this.inboundHeaderTextList.push('Net Weight');
        // this.inboundHeaderTextList.push('Bale Count');
        // this.inboundHeaderTextList.push('Inbound Remark');
        // this.inboundHeaderTextList.push('Plastic Count');
        // this.inboundHeaderTextList.push('Pallet Count');
        // this.inboundHeaderTextList.push('Plastic Weight');
        // this.inboundHeaderTextList.push('Pallet Weight');
        // this.inboundHeaderTextList.push('Supplier Name');
        // this.inboundHeaderTextList.push('Route Desc');
        // this.inboundHeaderTextList.push('Driver');

        // this.inboundDateFields.push('gwDate');
        // this.inboundDateFields.push('twDate');
        // this.inboundDateFields.push('apptDate');
        // this.inboundTimeFields.push('gwTime');
        // this.inboundTimeFields.push('twTime');
        // this.inboundTimeFields.push('gwDateWeb');
        // this.inboundTimeFields.push('twDateWeb');
        // this.inboundTimeFields.push('apptTime');

    },

    setupUserLayout()
    {
        // var layout_default = [];
        // var layout_1 = [];
        // var layout_2 = [];
        // layout_default.push('inboundStatus');
        // layout_default.push('sapStatus');
        // layout_default.push('receivingWindows');
        // layout_default.push('apptDate');
        // layout_default.push('apptTime');
        // layout_default.push('apptNo');
        // layout_default.push('matnr');
        // layout_default.push('scaleTicket');
        // layout_default.push('ibs');
        // layout_default.push('trailerNo');
        // layout_default.push('po');
        // layout_default.push('gwDate');
        // layout_default.push('gwTime');
        // layout_default.push('gwDateWeb');
        // layout_default.push('gwStation');
        // layout_default.push('gwYgNo');
        // layout_default.push('gwYgWeight');
        // layout_default.push('vgmWeight');
        // layout_default.push('twDate');
        // layout_default.push('twTime');
        // layout_default.push('twDateWeb');
        // layout_default.push('twStation');
        // layout_default.push('twYgNo');
        // layout_default.push('twYgWeight');
        // layout_default.push('tareWeight');
        // layout_default.push('weight');
        // layout_default.push('bales');
        // layout_default.push('loadRemark');
        // layout_default.push('plasticCount');
        // layout_default.push('palletCount');
        // layout_default.push('plasticWeight');
        // layout_default.push('palletWeight');
        // layout_default.push('supplier_name');
        // layout_default.push('route_desc');
        // layout_default.push('moveInBy');

        // layout_1.push('inboundStatus');
        // layout_1.push('receivingWindows');
        // layout_1.push('sapStatus');
        // layout_1.push('apptDate');
        // layout_1.push('apptTime');
        // layout_1.push('apptNo');
        // layout_1.push('matnr');
        // layout_1.push('scaleTicket');
        // layout_1.push('ibs');
        // layout_1.push('trailerNo');
        // layout_1.push('po');
        // layout_1.push('gwDate');
        // layout_1.push('gwTime');
        // layout_1.push('gwDateWeb');
        // layout_1.push('gwStation');
        // layout_1.push('gwYgNo');
        // layout_1.push('gwYgWeight');
        // layout_1.push('vgmWeight');
        // layout_1.push('twDate');
        // layout_1.push('twTime');
        // layout_1.push('twDateWeb');
        // layout_1.push('twStation');
        // layout_1.push('twYgNo');
        // layout_1.push('twYgWeight');
        // layout_1.push('tareWeight');
        // layout_1.push('weight');
        // layout_1.push('bales');
        // layout_1.push('loadRemark');
        // layout_1.push('plasticCount');
        // layout_1.push('palletCount');
        // layout_1.push('plasticWeight');
        // layout_1.push('palletWeight');
        // layout_1.push('supplier_name');
        // layout_1.push('route_desc');
        // layout_1.push('moveInBy');

        // layout_2.push('inboundStatus');
        // layout_2.push('apptDate');
        // layout_2.push('apptTime');
        // layout_2.push('sapStatus');
        // layout_2.push('receivingWindows');
        // layout_2.push('apptNo');
        // layout_2.push('matnr');
        // layout_2.push('scaleTicket');
        // layout_2.push('ibs');
        // layout_2.push('trailerNo');
        // layout_2.push('po');
        // layout_2.push('gwDate');
        // layout_2.push('gwTime');
        // layout_2.push('gwDateWeb');
        // layout_2.push('gwStation');
        // layout_2.push('gwYgNo');
        // layout_2.push('gwYgWeight');
        // layout_2.push('vgmWeight');
        // layout_2.push('twDate');
        // layout_2.push('twTime');
        // layout_2.push('twDateWeb');
        // layout_2.push('twStation');
        // layout_2.push('twYgNo');
        // layout_2.push('twYgWeight');
        // layout_2.push('tareWeight');
        // layout_2.push('weight');
        // layout_2.push('bales');
        // layout_2.push('loadRemark');
        // layout_2.push('plasticCount');
        // layout_2.push('palletCount');
        // layout_2.push('plasticWeight');
        // layout_2.push('palletWeight');
        // layout_2.push('supplier_name');
        // layout_2.push('route_desc');
        // layout_2.push('moveInBy');

        // console.log(`select inbound user layout: ${this.selectInboundLayout}`);
        // this.inbound_user_layout = [];
        // if (this.selectInboundLayout === 'inbound_layout_default')
        // {
        //     this.inbound_user_layout = layout_default;
        // }
        // if (this.selectInboundLayout === 'inbound_layout_1')
        // {
        //     this.inbound_user_layout = layout_1;
        // }
        // if (this.selectInboundLayout === 'inbound_layout_2')
        // {
        //     this.inbound_user_layout = layout_2;
        // }

        //this.loadUserLayout();
        //console.log(`setup inbound user layout: ${JSON.stringify(this.inbound_user_layout)}`);

    },

    setupInboundColWidth()
    {
      //  this.inboundColWidth10.push('supplier_name');
      //  this.inboundColWidth10.push('route_desc');

      //  this.inboundColWidth10.push('moveInBy');

      //  this.inboundColWidth5.push('inboundStatus');
      //  this.inboundColWidth5.push('sapStatus');
      //  this.inboundColWidth5.push('receivingWindows');
      //  this.inboundColWidth5.push('apptDate');
      //  this.inboundColWidth5.push('apptTime');
      //  this.inboundColWidth5.push('apptNo');
      //  this.inboundColWidth5.push('matnr');
      //  this.inboundColWidth5.push('scaleTicket');
      //  this.inboundColWidth5.push('ibs');
      //  this.inboundColWidth5.push('trailerNo');
      //  this.inboundColWidth5.push('po');
      //  this.inboundColWidth5.push('gwDate');
      //  this.inboundColWidth5.push('gwTime');
      //  this.inboundColWidth5.push('gwDateWeb');
      //  this.inboundColWidth5.push('gwStation');
      //  this.inboundColWidth5.push('gwYgNo');
      //  this.inboundColWidth5.push('gwYgWeight');
      //  this.inboundColWidth5.push('vgmWeight');
      //  this.inboundColWidth5.push('twDate');
      //  this.inboundColWidth5.push('twTime');
      //  this.inboundColWidth5.push('twDateWeb');
      //  this.inboundColWidth5.push('twStation');
      //  this.inboundColWidth5.push('twYgNo');
      //  this.inboundColWidth5.push('twYgWeight');
      //  this.inboundColWidth5.push('tareWeight');
      //  this.inboundColWidth5.push('weight');
      //  this.inboundColWidth5.push('bales');
      //  this.inboundColWidth5.push('loadRemark');
      //  this.inboundColWidth5.push('plasticCount');
      //  this.inboundColWidth5.push('palletCount');
      //  this.inboundColWidth5.push('plasticWeight');
      //  this.inboundColWidth5.push('palletWeight');

    },

    getInboundElementIndex(value)
    {
        // //var indx = 0;
        // //console.log(`element value: ');
        // //console.log(`element value: ${value}`);
        // for (var count = 0; count < this.inboundDataElmList.length; count++)
        // {
        //     //console.log(`element list value: ${this.inboundDataElmList[count]}`);
        //     if (this.inboundDataElmList[count] == value)
        //     {
        //         //console.log(`return value: ${count}`);
        //         return count
        //     }
        // }
        // return -1;
    },

    // getTimeFromDate(p_item, p_value)
    // {
    //    var retval = "";
    //    if (p_value != null && p_value != '')
    //    {
    //       retval = dateFormat.time(p_item[p_value]);
    //       if (p_value == 'gwTime')
    //         retval = dateFormat.time(p_item.gwDate);
    //       if (p_value == 'twTime')
    //         retval = dateFormat.time(p_item.twDate);
    //       if (p_value == 'apptTime')
    //         retval = dateFormat.time(p_item.apptDate);  
    //    }
    //    return retval;
    // },
  
    doSearch() {
      this.active = false;
      // console.log("shortId: " + this.searchRequest.shortId);
      // console.log("search msg: " + this.searchRequest.containMsg);

      // console.log("start date: " + formatStartDate(this.searchRequest.sendDate.startDate));
      // console.log("end date: " + formatEndDate(this.searchRequest.sendDate.endDate));
      if (this.unmatch_type)
      {
         console.log("log create start date: " + this.startdate);
         console.log("log create end date: " + this.enddate);
         if (this.startdate != null || this.enddate != null) {
            if (this.enddate == null || this.enddate == ""){
               this.searchRequest.logCreateDate.endDate = formatEndDate(this.startdate);   
            } else {
               this.searchRequest.logCreateDate.endDate = formatEndDate(this.enddate);
            }
            if (this.startdate)
               this.searchRequest.logCreateDate.startDate = formatStartDate(this.startdate);
            if (this.searchRequest.logCreateDate.startDate > this.searchRequest.logCreateDate.endDate) {
                alert("Error: Search Start Date is greater than End Date");
                return;
            } 
         } 
         console.log("start date: " + this.searchRequest.logCreateDate.startDate);
         console.log("end date: " + this.searchRequest.logCreateDate.endDate);
         //console.log("date format: " + dateFormat(new Date(this.searchRequest.sendDate.startDate), "yyyy-MM-dd'T'HH:mm:ss"))
         // if (this.searchRequest.driverMobile && this.searchRequest.driverMobile != "") {
         //   if (this.searchRequest.driverMobile.substring(0,2) != "+1") {
         //      if (this.searchRequest.driverMobile.substring(0,1) != "1")
         //        //console.log("substring driver mobile: " + this.searchRequest.driverMobile.substring(0,1));
         //        this.searchRequest.driverMobile = "1" + this.searchRequest.driverMobile;
         //      if (this.searchRequest.driverMobile.substring(0,1) != "+")
         //        //console.log("substring driver mobile: " + this.searchRequest.driverMobile.substring(0,1));
         //        this.searchRequest.driverMobile = "+" + this.searchRequest.driverMobile;
         //   }
         // }
         // if (this.searchRequest.driverMobile == "")
         //   this.searchRequest.driverMobile = null;   
         //else
         //   this.searchRequest.driverMobile = "+19095695793";
  
         //this.searchRequest.sendDate.startDate = "2022-01-01T08:00:00";
         //this.searchRequest.sendDate.endDate = "2022-02-28T08:00:00"   

         this.searchRequest.office = "FSI";
         this.searchRequest.user = "INBOUND";
         //this.searchRequest.unmatchRecWin = true;
         this.searchRequest.fromScaling = true;
         this.searchRequest.ibs = this.dataForm.ibs;
         this.searchRequest.actualScaleLocation = this.dataForm.actualScaleLocation;
         this.searchRequest.apptRecWin = this.dataForm.apptRecWin;
         this.searchRequest.ibsRecWin = this.dataForm.ibsRecWin;
         console.log(`request: ${JSON.stringify(this.searchRequest)}`);
         console.log("this.getFSIInboundUnmatchReport:" + JSON.stringify(this.getFSIInboundUnmatchReport));
         this.$nextTick(() => {
           this.$store.dispatch('FSIInboundUnmatchList', this.searchRequest);
         })
      }
      if (this.inbound_type)
      {
         this.active = false;

         //this.setupUserLayout();

         console.log(`inbound search layout: ${JSON.stringify(this.inbound_user_layout)}`);

         console.log("searchRadio:" + this.selectapptDate)

         if (this.selectapptDate == "apptDate" && this.inboundSearchRequest.apptDate.startDate == null ){
       
         if ( (this.inboundSearchRequest.ibs == null || this.inboundSearchRequest.ibs == "") &&
            ( this.inboundSearchRequest.ibd == null || this.inboundSearchRequest.ibd == "") && 
            ( this.inboundSearchRequest.po == null || this.inboundSearchRequest.po == "" ) )
         {   
            this.$buefy.notification.open({
                    duration: 5000,
                    message: `apptDate is requirement field!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
            return
         }}

         if (this.selectapptDate == "apptDate_null" && this.inboundSearchRequest.ibs_process_DT.startDate == null )
         {
            this.$buefy.notification.open({
                    duration: 5000,
                    message: `IBS process date is requirement field!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
            return
         }

         if (this.selectapptDate == "apptDate_null" && this.inboundSearchRequest.apptDate.startDate != null )
         {
            this.$buefy.notification.open({
                    duration: 5000,
                    message: `Please don't enter appointment date!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
            return
         }

         this.$nextTick(() => {
            this.$store.dispatch('ibsInboundsList', this.inboundSearchRequest);
          })
      }
      if (this.outbound_type)
      {
         if ((this.outboundSearchRequest.chzEndDate.startDate == null || this.outboundSearchRequest.chzEndDate.startDate == '')
              && (this.outboundSearchRequest.chzEndDate.endDate == null || this.outboundSearchRequest.chzEndDate.endDate == ''))
         {
            this.$buefy.notification.open({
                    duration: 5000,
                    message: `In Gate date is requirement field!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
            return
         }
         this.$nextTick(() => {
            this.$store.dispatch('ibsOutboundsList', this.outboundSearchRequest);
         })
      }
    },

    doClear() {
      console.log("doClear::startdate: " + this.startdate);
      _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
            this.searchRequest = getInitSearch();
            if (this.startdate)
               this.startdate = null;
            if (this.enddate)   
               this.enddate = null;
          });
      this.$nextTick(() => {
        //  this.searchRequest = getInitSearch();
        //  if (this.startdate)
        //     this.startdate = null;
        //  if (this.enddate)   
        //     this.enddate = null;
         console.log("doClear::startdate (after): " + this.startdate);
      });
      //this.$forceUpdate();
    },

    filterBar(){
      this.isFilterModalShowing = true;
    },

    includeNull(field) {
      return field == null ? "" : field;
    },

    sortFunction(sortField){
      console.log(`calling sort function`);
      var sorted = [];
      if (this.inbound_type)
      {
         sorted = sort(this.items_inbound).asc(sortField);
      } else if (this.outbound_type) {
         sorted = sort(this.items_outbound).asc(sortField);
      } else {
         sorted = sort(this.items).asc(sortField);
      }
      this.sortStatus = !this.sortStatus;
      console.log(`sort status: ${this.sortStatus}`);
      console.log(`sorted items: ${JSON.stringify(sorted)}`);
      if (this.sortStatus)
      {
        if (this.inbound_type)
        {
           this.items_inbound = sorted;
        } else if (this.outbound_type) {
           this.items_outbound = sorted;
        } else {  
           this.items = sorted;
        }
      }
      else
      {
        if (this.inbound_type) {
           this.items_inbound = sorted.reverse();
        } else if (this.outbound_type) {
           this.items_outbound = sorted.reverse();
        } else {  
           this.items = sorted.reverse();
        }
      }
            
    },

    onSelectreport(id) {
      console.log(`report type id: ${id}`);
      if (id == 'report_inbound')
      {
         this.inbound_type = true;
         this.outbound_type = false;
         this.unmatch_type = false;
         this.layout_type = "Inbound Layout";
      }   
      if (id == 'report_outbound')
      {
         this.inbound_type = false;
         this.outbound_type = true;
         this.unmatch_type = false;
         this.layout_type = "Outbound Layout";
      }   
      if (id == 'report_unmatch')
      {
         this.inbound_type = false;
         this.outbound_type = false;
         this.unmatch_type = true;
         this.layout_type = "Un-Match Layout";
      }   
      this.doReloadLayout();

    },

    onSelectappt(id)
    {
      console.log("select:" + this.selectapptDate);
      if(this.selectapptDate == "apptDate"){

        this.inboundSearchRequest.apptDate.startDate = moment().subtract(1,'months').startOf('d').toDate();
        this.inboundSearchRequest.apptDate.endDate = moment().endOf('d').toDate();
        this.inboundSearchRequest.ibs_process_DT.startDate = null;
        this.inboundSearchRequest.ibs_process_DT.endDate = null;
        this.$refs.refibsprocessDateF.querySelector('button.md-clear').click();
        this.$refs.refibsprocessDateT.querySelector('button.md-clear').click();

      }
      else{
        console.log("selectapptDate_null");

        this.inboundSearchRequest.ibs_process_DT.startDate = moment().subtract(1,'months').startOf('d').toDate();
        this.inboundSearchRequest.ibs_process_DT.endDate = moment().endOf('d').toDate();
        this.inboundSearchRequest.apptDate.startDate = null;
        this.inboundSearchRequest.apptDate.endDate = null;
        this.$refs.refapptDateF.querySelector('button.md-clear').click();
        this.$refs.refapptDateT.querySelector('button.md-clear').click();

      }
       
    },


    doDownloadExcel(){
       var reportName = 'InboundUnmatchReport.xls';
       if (this.inbound_type)
       {
          reportName = 'Inbound_IBS_Report.xls';
       }
       if (this.outbound_type)
       {
          reportName = 'Outbound_IBS_Report.xls';
       }
       this.setupUserLayout();
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
                                  reportName,
                                  0,
          );
          if (this.unmatch_type)
          {
             request.heads = _(request.heads).take(19);
             console.log(`request heads: ${request.heads} length: ${request.heads.length}`);
             request.rows = _(this.items)
                .map(item => [
                     item.user,
                     item.webModule,
                     dateFormat.date(item.createdAt),
                     item.apptRecWin,
                     item.ibsRecWin,
                     dateFormat.date(item.apptDate),
                     dateFormat.date(item.chzEndDate),
                     item.matnr,
                     item.scaleTicket,
                     item.ibs,
                     item.containerNo,
                     item.gwYgNo,
                     item.gwYgWeight,
                     item.vgmWeight,
                     item.twYgNo,
                     item.twYgWeight,
                     item.tareWeight,
                     item.weight,
                     item.bales, 
                ]);
          }
          if (this.outbound_type)
          {
             request.heads = _(request.heads).take(29);
             console.log(`request heads: ${request.heads} length: ${request.heads.length}`);
             request.rows = _(this.items_outbound)
                .map(item => [
                     item.loadStatus,
                     item.sapStatus,
                     item.receivingWindows,
                     dateFormat.date(item.chzEndDate),
                     dateFormat.date(item.chzStartDate),
                     item.newSeal,
                     item.grade,
                     item.scaleTicket,
                     item.containerNo,
                     item.chassisNo,
                     item.bookingNo,
                     dateFormat.date(item.gwDate),
                     dateFormat.time(item.gwDate),
                     dateFormat.time(item.gwDateWeb),
                     item.gwStation,
                     item.gwYgNo,
                     item.gwYgWeight,
                     item.vgmWeight,
                     dateFormat.date(item.twDate),
                     dateFormat.time(item.twDate),
                     dateFormat.time(item.twDateWeb),
                     item.twStation,
                     item.twYgNo,
                     item.twYgWeight,
                     item.tareWeight,
                     item.weight,
                     item.bales,
                     item.outboundRemark,
                     item.carrier2,
                ]);
          }
          if (this.inbound_type)
          {
             var row = []; 
             var rows = [];
             
             var p_items = this.checkboxFilter.filter(it => this.loaded_recwin_id.includes(it.receivingWindows)).filter((row) => {
                       const term = this.filter.toUpperCase().trim();
                       return (
                         this.includeNull(row.ibs).includes(term) ||
                         this.includeNull(row.po).includes(term) ||
                         this.includeNull(row.apptNo).includes(term) ||
                         this.includeNull(row.scaleTicket).includes(term)
                       );
                    });
             //console.log(`export excel content: ${JSON.stringify(p_items)}`);       
             //this.items_inbound.forEach((item) =>{
             p_items.forEach((item) => {
                //this.inbound_user_layout.forEach((it => {
                this.loaded_user_layout.forEach((it) =>{
                   //if (this.inboundDateFields.includes(it))
                   if (it.colDataType == 'DATE')
                   {
                      row.push(dateFormat.date(item[it.colDataElement]))
                   } else {
                     //if (this.inboundTimeFields.includes(it))
                     if (it.colDataType == 'TIME')
                     {
                        // if (it === 'gwTime')
                        // {
                        //     row.push(dateFormat.time(item.gwDate));
                        // }
                        // if (it === 'twTime')
                        // {
                        //     row.push(dateFormat.time(item.twDate));
                        // }
                        // if (it === 'apptTime')
                        // {
                        //     row.push(dateFormat.time(item.apptDate));
                        // }
                        row.push(dateFormat.time(item[it.colDataElement]))
                     } else {
                       row.push(item[it.colDataElement])
                     }
                   }
                });
                console.log(`row length: ${row.length}`);
                rows.push(row);
                row = [];
             })
             //console.log(`rows: ${JSON.stringify(rows)}`);
             //get runtime column amount
             const p_col_len = request.heads.length;
             //console.log(`head col length: ${p_col_len}`);
             //request.heads = _(request.heads).take(39);
             request.heads = _(request.heads).take(p_col_len);
             //console.log(`request heads: ${request.heads} length: ${request.heads.length}`);
             request.rows = _(rows);
            //  request.rows = _(this.items_inbound)
            //     .map(item => [
            //          item.inboundStatus,
            //          item.sapStatus,
            //          item.receivingWindows,
            //          dateFormat.date(item.apptDate),
            //          dateFormat.time(item.apptDate),
            //          item.apptNo,
            //          item.matnr,
            //          item.scaleTicket,
            //          item.ibs,
            //          item.trailerNo,
            //          item.po,
            //          dateFormat.date(item.gwDate),
            //          dateFormat.time(item.gwDate),
            //          item.gwDate,
            //          item.gwStation,
            //          item.gwYgNo,
            //          item.gwYgWeight,
            //          item.vgmWeight,
            //          dateFormat.date(item.twDate),
            //          dateFormat.time(item.twDate),
            //          item.twDate,
            //          item.twStation,
            //          item.twYgNo,
            //          item.twYgWeight,
            //          item.tareWeight,
            //          item.weight,
            //          item.bales,
            //          item.loadRemark,
            //          item.plasticCount,
            //          item.palletCount,
            //          item.plasticWeight,
            //          item.palletWeight,
            //          item.supplier_name,
            //          item.route_desc,
            //          item.moveInBy,
            //     ]);
          }
          this.$store.dispatch('generateExcel', request)
            .then((res) => {
               window.open(res.url, 'blank');
            });
          this.isdisableSend = true; 
          this.isdisablephoto = true; 
    }, 

    async doReloadLayout()
    {
        //this.loadUserLayout();
        this.loaded_default_allCols = [];
        await this.getLayoutNameList()
        .then(() => {
           this.loadUserLayout('',true, true)
           .then(() => {
              console.log(`user spec default layout: ${JSON.stringify(this.loaded_default_allCols)}`)
              if (this.loaded_default_allCols.length <= 0)
              {
                 this.loadUserLayout('',true, false)
                 .then(() => {
                    console.log(`general default layout: ${JSON.stringify(this.loaded_default_allCols)}`)
                    this.loaded_user_layout = this.loaded_default_allCols;
                 });
              } else {
                 this.loaded_user_layout = this.loaded_default_allCols;
              }
           });

        });
    },

    // getLayoutInfo(layoutname)
    // {
    //     //var p_items = [];
    //     //loadlayoutname = "DEFAULT";
    //     console.log(`layoutname: ${layoutname}`);
    //     this.layoutSearchRequest = getInitialLayoutSearchRequest();
    //     this.layoutSearchRequest.office = "FSI";
    //     //this.layoutSearchRequest.layoutName = "DEFAULT";
    //     if (layoutname != null && layoutname != "")
    //     {
    //         if (layoutname != 'ALL')
    //         {
    //            this.layoutSearchRequest.layoutName = layoutname;
    //         }
    //     }
    //     this.layoutSearchRequest.reportModule = "IBSLIST_INBOUND";
    //     this.layoutSearchRequest.onlyActive = true;
    //     this.$store.dispatch('loadlayoutdata', this.layoutSearchRequest);
    //     this.updateReportLayout(this.getreportlayoutdata);
    //     console.log(`after select layout to load: ${JSON.stringify(this.inbound_user_layout)}`);
    //     console.log(`inbound layout length: ${this.inbound_user_layout.length}`);
    // },

    async loadUserLayout(loadlayoutname,loaddefaultallcols,userspecific)
    {
         var p_items = [];
        //loadlayoutname = "DEFAULT";
        console.log(`loadlayoutname: ${loadlayoutname}`);
        this.layoutSearchRequest = getInitialLayoutSearchRequest();
        this.layoutSearchRequest.office = "FSI";
        if (userspecific)
        {
            this.layoutSearchRequest.userSpecific = userspecific;
        }
        if (loaddefaultallcols)
        {
            this.layoutSearchRequest.setDefault = true;
        }
        //this.layoutSearchRequest.layoutName = "DEFAULT";
        if (loadlayoutname != null && loadlayoutname != "")
        {
            this.layoutSearchRequest.layoutName = loadlayoutname;
        }
        if (this.selectreportType == 'report_inbound')
           this.layoutSearchRequest.reportModule = "IBSLIST_INBOUND";
        if (this.selectreportType == 'report_outbound')  
           this.layoutSearchRequest.reportModule = "IBSLIST_OUTBOUND";
        if (this.selectreportType == 'report_unmatch')  
           this.layoutSearchRequest.reportModule = "IBSLIST_UNMATCH";
        this.layoutSearchRequest.onlyActive = true;
        // this.$store.dispatch('loadlayoutdata', this.layoutSearchRequest);
        // this.updateReportLayout(this.getreportlayoutdata);
        // console.log(`after select layout to load: ${JSON.stringify(this.inbound_user_layout)}`);
        // console.log(`inbound layout length: ${this.inbound_user_layout.length}`);
        //do the sorting
        //await this.getLayoutInfo(loadlayoutname)
        //await api.post('/api/w/layout/Search', this.layoutSearchRequest)
        await newAPIPost('/api/w/layout/Search', this.layoutSearchRequest)
        .then((val) => {
           //if (this.loadedUserLayout.length > 0)
           if (val != null && val.layoutInfoList != null && val.layoutInfoList.length > 0)
           {
               //for (var i = 1; i < this.loadedUserLayout.length + 1; i++)
               for (var i = 1; i < val.layoutInfoList.length + 1; i++)
               {
                   var p_index = i.toString();
                   //var selectedrow = this.loadedUserLayout.filter(it => it.colIndex == p_index);
                   var selectedrow = val.layoutInfoList.filter(it => it.colIndex == p_index);
                   if (selectedrow != null)
                   {
                      if (selectedrow.length > 0)
                      {
                         if (selectedrow[0].userSpecific != null)
                         {
                            this.loaded_layout_userspec = selectedrow[0].userSpecific;   
                         } else {
                            this.loaded_layout_userspec = false;
                         }
                         if (selectedrow[0].setDefault != null)
                         {
                            this.loaded_layout_setdefault = selectedrow[0].setDefault;
                         } else {
                            this.loaded_layout_setdefault = false
                         }
                         
                         
                         this.selectedLayout = selectedrow[0].layoutName;
                         console.log(`selected row: ${JSON.stringify(selectedrow[0])}`);
                         var p_row = reportLayoutElements();
                         p_row.orderIndex = i.toString();
                         p_row.colDataElement = selectedrow[0].colDataElement;
                         p_row.colHeaderText = selectedrow[0].colHeaderText;
                         p_row.colWidth = selectedrow[0].colWidth;
                         p_row.colDataType = selectedrow[0].colDataType;
                         if (!p_items.includes(p_row))
                         {
                            p_items.push(p_row);    
                         }
                      }
                   }   
                }
            }
            if (!loaddefaultallcols)
            {
               this.loaded_user_layout = [];
               this.loaded_user_layout = p_items;
               console.log(`layout p items: ${JSON.stringify(p_items)} and row count: ${p_items.length}`);
               console.log(`layout user: ${JSON.stringify(this.loaded_user_layout)} and row count: ${this.loaded_user_layout.length}`);
            } else {
              this.loaded_default_allCols = [];
              this.loaded_default_allCols = p_items;
              console.log(`default layout p items: ${JSON.stringify(p_items)} and row count: ${p_items.length}`);
              console.log(`layout default all: ${JSON.stringify(this.loaded_default_allCols)} and row count: ${this.loaded_default_allCols.length}`);
            }
        });
    },

    // loadUserLayout(userlayoutname)
    // {
    //     var p_items = [];
    //     this.layoutSearchRequest.office = "FSI";
    //     //this.layoutSearchRequest.layoutName = "DEFAULT";
    //     if (userlayoutname != null && userlayoutname != "")
    //     {
    //         this.layoutSearchRequest.layoutName = userlayoutname;
    //     }
    //     this.layoutSearchRequest.reportModule = "IBSLIST_INBOUND";
    //     this.layoutSearchRequest.onlyActive = true;
    //     this.$store.dispatch('loadlayoutdata', this.layoutSearchRequest);
    //     this.updateReportLayout(this.getreportlayoutdata);
    //     console.log(`after select layout to load: ${JSON.stringify(this.inbound_user_layout)}`);
    //     console.log(`inbound layout length: ${this.inbound_user_layout.length}`);
    // },

    async getLayoutNameList()
    {
        var p_layoutnames = [];
        this.layoutSearchRequest = getInitialLayoutSearchRequest();
        this.layoutSearchRequest.office = "FSI";
        //this.layoutSearchRequest.layoutName = "DEFAULT";
        // if (userlayoutname != null && userlayoutname != "")
        // {
        //     this.layoutSearchRequest.layoutName = userlayoutname;
        // }
        if (this.selectreportType == 'report_inbound')
           this.layoutSearchRequest.reportModule = "IBSLIST_INBOUND";
        if (this.selectreportType == 'report_outbound')  
           this.layoutSearchRequest.reportModule = "IBSLIST_OUTBOUND";
        if (this.selectreportType == 'report_unmatch')  
           this.layoutSearchRequest.reportModule = "IBSLIST_UNMATCH";
        //this.layoutSearchRequest.reportModule = "IBSLIST_INBOUND";
        this.layoutSearchRequest.layoutnamelist = true;
        this.layoutSearchRequest.onlyActive = true;
        // console.log(`get layout name list request: ${JSON.stringify(this.layoutSearchRequest)}`);
        // this.$store.dispatch('loadlayoutdata', this.layoutSearchRequest);
        // this.updateReportLayout(this.getreportlayoutdata);
        // console.log(`user layout: ${JSON.stringify(this.loadedUserLayout)}`);
        //console.log(`after select layout to load: ${JSON.stringify(this.inbound_user_layout)}`);
        //console.log(`inbound layout length: ${this.inbound_user_layout.length}`);
        //await this.getLayoutInfo('ALL')
        //await api.post('/api/w/layout/Search', this.layoutSearchRequest)
        await newAPIPost('/api/w/layout/Search', this.layoutSearchRequest)
        .then((val) => {
           //if (this.loadedUserLayout.length > 0)
           if (val != null && val.layoutNameList != null && val.layoutNameList.length > 0)
           {
               //this.loadedUserLayout.forEach((it) => {
               val.layoutNameList.forEach((it) => { 
                   if (!p_layoutnames.includes(it))
                   {
                      p_layoutnames.push(it);
                   }
               });
               this.userLayoutNameList = p_layoutnames;
               console.log(`name list: ${JSON.stringify(this.userLayoutNameList)}`);
           }
        });
    },

    loadLayout()
    {
        if (this.selectedLayout != null && this.selectedLayout != "")
        {
            this.loadUserLayout(this.selectedLayout);
        }
    },
    createLayout()
    {
        var update_layout = [];
        var process_report_module = '';
        if (this.selectreportType == 'report_inbound')
           process_report_module = "IBSLIST_INBOUND";
        if (this.selectreportType == 'report_outbound')  
           process_report_module = "IBSLIST_OUTBOUND";
        if (this.selectreportType == 'report_unmatch')  
           process_report_module = "IBSLIST_UNMATCH";

        this.loadUserLayout('',true,false)
        .then(() => {
           update_layout = this.loaded_default_allCols;
           this.$refs.CreateLayoutForm.openDialog(process_report_module, this.selectedLayout, update_layout, this.loaded_default_allCols, false, false);
        });

    },
    updateLayout()
    {
        var update_layout = [];
        var process_report_module = '';
        if (this.selectreportType == 'report_inbound')
           process_report_module = "IBSLIST_INBOUND";
        if (this.selectreportType == 'report_outbound')  
           process_report_module = "IBSLIST_OUTBOUND";
        if (this.selectreportType == 'report_unmatch')  
           process_report_module = "IBSLIST_UNMATCH";
        console.log(`selected layout: ${this.selectedLayout}`);
        this.loadUserLayout(this.selectedLayout)
        .then(() => {
           update_layout = this.loaded_user_layout;
           this.$refs.UpdateLayoutForm.openDialog(process_report_module, this.selectedLayout, update_layout, this.loaded_default_allCols, this.loaded_layout_userspec, this.loaded_layout_setdefault);
        });
        //this.inbound_default_allCols = [];
        //this.loadUserLayout('DEFAULT_ALL', true)
        //.then(() => {
        //});
    },
    docreate(id)
    {
       console.log(`return id: ${id}`);
       this.getLayoutNameList();
    },
    doupdate(id)
    {
       console.log(`return id: ${id}`);
    },

    async refreshAction(){
        // const req = this.requestdatabackup;
        // this.getInitialSMSLog();
        // if (req != null && req.length > 0)
        // {
        //    req.forEach( (it) => {
        //        this.smslogForm.inbound
        //    }

        //    )
        // }
        // console.log("inboundshipment: " + this.dataForm.inboundShipment);
        //if (document.getElementById("pb"))
        //{
        //   document.getElementById("pb").style.display = "";
        //}
        while (this.getLog.length > 0) {this.getLog.pop()}
        this.items.forEach( (it) => {
           console.log("InboundShipment in loop: " + it.inboundShipment);
           this.smslogForm = getInitialSMSLog();
           this.smslogForm.inboundShipment = it.inboundShipment;
           console.log("actual loadKey: " + it.loadKey);
           this.smslogForm.loadKey = it.loadKey;
           this.smslogForm.messageId = it.messageId;
           this.smslogForm.sendDate = it.sendDate;
           console.log("smslogForm: " + this.smslogForm.inboundShipment);
           this.getLog.push(this.smslogForm)
        })

        console.log("smslogForm size: " + this.getLog.length);
        //const refreshLog = api.post('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
        const refreshLog = newAPIPost('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
        .then((it) => {
          console.log("messageId: " + it[0].messageId + " and size: " + it.length);
          //this.smsLog = it;
          this.items = it;
          //if (document.getElementById("pb"))
          //{ 
          //   document.getElementById("pb").style.display = "none";
          //}
        }
        )
     },

    handleScroll(e) {
       if (this.$el)
       {
         $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
             .offset().left),
         });
       }
    },

    // getMaxId() {
    //   return '100008';
    // },

//     sortFunction(sortFiled){
//       //const sorted = sort(this.items).asc(sortFiled);
//       const sorted = _(this.items).sortBy(sortFiled);
//       this.sortStatus = !this.sortStatus;
//       console.log(this.sortStatus)
//       console.log(this.smslog)
//     if (this.sortStatus)
//       {
//         this.items = sorted;
//       }
//     else
//       {
//       this.items = sorted.reverse();
//     }
            
// },

        //  sortFunction(sortFiled){
        //         const sorted = _(this.items).sortBy(sortFiled);
        //         console.log(this.sortStatus);
        //         this.sortStatus = !this.sortStatus;
        //         if (this.sortStatus == "ASCENDING" || this.sortStatus == null)
        //         {
        //             this.items = sorted;
        //         }
        //         else
        //         {
        //             this.items = sorted.reverse();
        //         }
                
        //   },


},
}
function formatStartDate(date) {
  if (date) {
     var year = date.getFullYear();
     var month = date.getMonth();
     var day = date.getDate();
     month += 1;
     if (month < 10)
        month = "0" + month;
     if (day < 10)
        day = "0" + day;
     return year + "-" + month + "-" + day + "T00:00:00";
  } else {
     return "";
  }
}
function formatEndDate(date) {
  console.log("formatEndDate::date: " + date);
  if (date) {
     var year = date.getFullYear();
     var month = date.getMonth();
     var day = date.getDate();
     month += 1;
     if (month < 10)
        month = "0" + month;
     if (day < 10)
        day = "0" + day;
     console.log("month: " + month);
     return year + "-" + month + "-" + day + "T23:59:59";
  } else {
     return "";
  }
}
</script>